export { default } from './PlaceHolderImage';
